import React from 'react';

import { forceReloadTask } from '@hooks/API/Event/UseTask';

import { EventActionsToolbar } from '@components/EventDrawer/EventDrawerUi/EventUI';
import { NwAddButton } from '@components/Gui/NwButton';
import NwUpload from '@components/Gui/NwUpload';

const TaskActions = ({ plainMode, taskData, onAddModels }) => {
    const getUploadEndpoint = () => {
        let endpoint = `documents/upload/1?eventGroupGuid=${taskData.GroupGuid}`;
        if (taskData.Project) {
            endpoint = endpoint + `&projectID=${taskData.Project.ID}`;
        }
        return endpoint;
    };

    return (
        <EventActionsToolbar plainMode={plainMode}>
            {taskData.GroupGuid && (
                <NwUpload
                    size="small"
                    label="add document"
                    maxSize={20}
                    showList={false}
                    types={['all']}
                    onUploadEnd={() => {
                        forceReloadTask(taskData.ID);
                    }}
                    endpoint={getUploadEndpoint()}
                />
            )}
            <NwAddButton size="small" ghost onClick={onAddModels} label="add models" />
        </EventActionsToolbar>
    );
};

export default TaskActions;
